import { useEffect, useContext } from 'react';
import { useLocalStore } from '../../../../Hooks/useLocalStore';
import { GlobalStates } from '../../../../GlobalStates';
import { setTabStorage } from '../../../../utils/tabStorage';
import useGlobalData from '../../../../Hooks/useGlobalData';

export const useFilters = ({
    t,
    filtersMain,
    setFilterMain,
    user,
    setYear
}) => {
    const { type } = useContext(GlobalStates);
    const isUserAdmin = (user && user.adminConfirmed) || type === 0;
    const { data: tipas, setData: setTipas } = useLocalStore('tipas');
    const { setData: setKlausimas } = useLocalStore('klausimas');
    const { setSelectedCompany } = useGlobalData();

    useEffect(() => {
        if (!filtersMain.kasPildo) {
            const darbuotojoForma = t('pildytojuTipai2', { returnObjects: true })[0];
            handleFormTypeChange({ target: { value: darbuotojoForma } });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // This effect should only run on mount to set initial default

    // const clearSavedYear = () => {
    //     localStorage.removeItem('currentYear');
    //     setYear(undefined);
    // };

    const handleYearChange = (event) => {
        const newYear = event.target.value;
        setYear(newYear);
        setTabStorage('currentYear', newYear.toString());

        // Išsaugome esamą įmonės filtrą - jį išlaikome keičiant metus
        // Nenaudojame kopijos, nes nenorime prarasti įmonės filtro
        // setFilterMain(filtersMain); // Nebereikia jokio filtro atnaujinimo
    };

    const handleCompanyChange = (event) => {
        setKlausimas(undefined);
        
        const selectedCompany = event.target.value;
        
        if (selectedCompany && selectedCompany !== 'all') {
            // Set specific company
            setSelectedCompany(selectedCompany);
            setFilterMain({
                ...filtersMain,
                imonesPavadinimas: selectedCompany,
                imone: selectedCompany
            });
        } else {
            // Clear company selection - sync with global state
            setSelectedCompany(null);
            const newFiltersMain = { ...filtersMain };
            delete newFiltersMain.imonesPavadinimas;
            delete newFiltersMain.imone;
            setFilterMain(newFiltersMain);
        }
    };

    const handleFormTypeChange = (event) => {
        const newValue = event.target.value;

        setTipas(newValue);
        setKlausimas(undefined);
        
        // Clear company selection when changing form type (for admins) - but keep global companies
        if (isUserAdmin) {
            setSelectedCompany(null);
        }

        const newFilters = { 
            kasPildo: newValue,
            ...(!isUserAdmin ? { 
                imonesPavadinimas: user.imonesPavadinimas 
            } : {})
        };
        setFilterMain(newFilters);
    };

    return {
        tipas,
        handleYearChange,
        handleCompanyChange,
        handleFormTypeChange
    };
};